const NestContents = {
  en: {
    deviceView: {
      nestChoiceText: `Select which Nest Thermostat you’d like your Awair to connect with.`,
      nestLogoutBtnText: 'Sign Out of Nest'
    },
    settingView: {
      settingGuideText1: {
        'awair': 'Set up your ranges for CO₂, VOCs, and Dust below and let Awair work with Nest to help you create healthy and comfortable environment.',
        'awair-r2': 'Set up your ranges for CO₂, VOCs, and Fine Dust below and let Awair work with Nest to help you create healthy and comfortable environment.',
        'awair-omni': 'Set up your ranges for CO₂, VOCs, and Fine Dust below and let Awair work with Nest to help you create healthy and comfortable environment.',
        'awair-mint': 'Set up your ranges for VOCs and Fine Dust below and let Awair work with Nest to help you create healthy and comfortable environment.',
        'awair-glow': 'Set up your ranges for CO₂ and VOCs below and let Awair work with Nest to help you create healthy and comfortable environment.',
        'awair-glow-c': 'Set up your ranges for VOCs below and let Awair work with Nest to help you create healthy and comfortable environment.'
      },
      settingGuideText2: 'Your fan will be turned on for the amount of time you specify in your Nest fan timer setting in Nest app. Nest thermostat should be online and not in away status.',
      moveNestAppBtnText: 'Go to Nest app',
      disconnectNestBtnText: 'Remove All Conditions'
    }
  },
  ko: {
    deviceView: {
      nestChoiceText: '어웨어와 연결하고 싶은 네스트 온도조절기를 선택해 주세요.',
      nestLogoutBtnText: '네스트에서 로그아웃'
    },
    settingView: {
      settingGuideText1: {
        'awair': '아래에서 원하는 이산화탄소, 화학물질, 미세먼지 범위를 설정하세요. 어웨어가 네스트를 통해 건강하고 편안한 실내환경을 만들어 드립니다.',
        'awair-r2': '아래에서 원하는 이산화탄소, 화학물질, 초미세먼지 범위를 설정하세요. 어웨어가 네스트를 통해 건강하고 편안한 실내환경을 만들어 드립니다.',
        'awair-omni': '아래에서 원하는 이산화탄소, 화학물질, 초미세먼지 범위를 설정하세요. 어웨어가 네스트를 통해 건강하고 편안한 실내환경을 만들어 드립니다.',
        'awair-mint': '아래에서 원하는 화학물질, 초미세먼지 범위를 설정하세요. 어웨어가 네스트를 통해 건강하고 편안한 실내환경을 만들어 드립니다.',
        'awair-glow': '아래에서 원하는 이산화탄소, 화학물질 범위를 설정하세요. 어웨어가 네스트를 통해 건강하고 편안한 실내환경을 만들어 드립니다.',
        'awair-glow-c': '아래에서 원하는 화학물질 범위를 설정하세요. 어웨어가 네스트를 통해 건강하고 편안한 실내환경을 만들어 드립니다.'
      },
      settingGuideText2: '네스트에서 설정한 시간동안 팬이 자동으로 돌게 됩니다. 네스트가 온라인 상태이며 Away 상태가 아니어야 작동합니다.',
      moveNestAppBtnText: '네스트 앱으로 이동하기',
      disconnectNestBtnText: '모든 설정 초기화'
    }
  }
};

export default NestContents;


// WEBPACK FOOTER //
// ./src/assets/contents/nest.js